<template>
  <div>
    <b-navbar v-if="desktop || largeDesktop" toggleable="md" type="light" class="ctm py-4 px-4">
      <div class="sidebar-header">
        <transition>
          <button v-if="desktop || largeDesktop" type="button" @click="showMenu" id="sidebarCollapse"
                  class="btn burger">
            <i class="fas fa-bars"></i>
          </button>
        </transition>
        <img src="../assets/logo.svg" class="logo"/>
        <h2>Fill-Bill</h2>
        <div class="vertslash">
          <h2>|</h2>
        </div>
        <h2>{{ $route.meta.name }}</h2>
      </div>
      <b-collapse is-nav id="nav_collapse" style="display: contents;">
        <b-navbar-nav class="ml-auto user">
          <b-nav-item-dropdown right>
            <template slot="button-content">
              <i class="fas fa-user-circle mr-2"></i>
              <span v-if="userInfo">{{ userInfo.user_profile.full_name }}</span>
            </template>
            <b-dropdown-item v-if="!admin && hasAdminMenu" @click="changeLocationToAdmin">Администрирование
            </b-dropdown-item>
            <b-dropdown-item v-if="admin && hasAdminMenu" @click="changeLocationToUser">Выйти из администрирования
            </b-dropdown-item>
            <b-dropdown-divider v-if="hasAdminMenu"></b-dropdown-divider>
            <b-dropdown-item @click="logout">Выход</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <nav v-if="mobile || tablet" class="d-flex align-items-center justify-content-between py-2 px-2">
      <div class="navbar-header d-flex align-items-center justify-content-between">
        <button type="button" v-b-toggle.sidebar-mobile class="btn burger">
          <i class="fas fa-bars"></i>
        </button>
        <img class="ml-3 mr-3" src="../assets/logo.svg"/>
        <span class="section-title">{{ $route.meta.name }}</span>
      </div>
      <b-dropdown size="md" variant="link" dropleft toggle-class="text-decoration-none" no-caret>
        <template v-slot:button-content>
          <i class="fas fa-user-circle"></i>
        </template>
        <b-dropdown-item v-if="userInfo">{{ userInfo.user_profile.full_name }}</b-dropdown-item>
        <b-dropdown-divider v-if="userInfo"></b-dropdown-divider>
        <b-dropdown-item v-if="!admin && hasAdminMenu" @click="changeLocationToAdmin">Администрирование
        </b-dropdown-item>
        <b-dropdown-item v-if="admin && hasAdminMenu" @click="changeLocationToUser">Выйти из администрирования
        </b-dropdown-item>
        <b-dropdown-divider v-if="hasAdminMenu"></b-dropdown-divider>
        <b-dropdown-item @click="logout">Выход</b-dropdown-item>
      </b-dropdown>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import menu from './menu.js'

export default {
  name: 'main-header',
  data () {
    return {
      admin: false,
      userMenu: menu.userMenu,
      adminMenu: menu.adminMenu
    }
  },
  computed: {
    ...mapState(
      {
        userInfo: state => state.authorization.userInfo,
        isAdminPart: state => state.isAdminPart,
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop
      }
    ),
    hasAdminMenu () {
      return this.userInfo && (this.userInfo.rights.menu_admin.length > 0)
    }
  },
  mounted () {
    if (this.isAdminPart) {
      this.admin = true
    }
  },
  methods: {
    logout () {
      this.goToUserPart()
      localStorage.setItem('isAdminPart', this.isAdminPart)
      this.logOut()
        .then(() => {
          this.$router.push('/login')
        })
    },
    changeLocationToAdmin () {
      this.goToAdminPart()
      localStorage.setItem('isAdminPart', this.isAdminPart)
      if (this.$route.name !== 'main-container') {
        this.$router.push('/')
      }
    },
    changeLocationToUser () {
      this.goToUserPart()
      localStorage.setItem('isAdminPart', this.isAdminPart)
      if (this.$route.name !== 'main-container') {
        this.$router.push('/')
      }
    },
    ...mapActions({
      logOut: 'authorization/logout'
    }),
    ...mapMutations({
      showMenu: 'toggleMenu',
      setUserInfo: 'authorization/setUserInfo',
      goToAdminPart: 'goToAdminPart',
      goToUserPart: 'goToUserPart'
    })
  },
  watch: {
    '$route' (to, from) {
      if (to.meta.title === 'user' && !this.isAdminPart) {
        this.admin = false
      }
      if (to.meta.title === 'user' && this.isAdminPart) {
        this.admin = true
      }
      if (to.meta.title === 'admin') {
        this.admin = true
      }
    },
    isAdminPart (to, from) {
      to ? this.admin = true : this.admin = false
    },
    mobile (to, from) {
      // console.log(to)
    },
    tablet (to, from) {
      // console.log(to)
    },
    desktop (to, from) {
      // console.log(to)
    },
    largeDesktop (to, from) {
      // console.log(to)
    }
  }
}
</script>

<style scoped>
  nav.navbar {
    margin-bottom: 0px;
  }

  .logo {
    margin: 0 16px;
  }

  .vertslash {
    display: block;
    margin: 0 15px 0 10px;
    position: relative;
  }

  .vertslash h2 {
    position: absolute;
    top: -16px;
  }

  .navbar.ctm {
    background: #ffffff;
    padding: 9px 13px;
  }

  .burger {
    background-color: #ffffff;
  }

  .btn.burger:focus {
    box-shadow: none;
  }

  .section-title {
    font-size: 14px;
    font-weight: 500;
  }
</style>
